import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRegisterData, registerUser } from '../../actions/login';
import RegisterFormView from './RegisterFormView';

class RegisterForm extends React.Component {
  componentWillMount() {
    this.props.getRegisterData();
  }

  onSubmit = data => {
    this.props.registerUser(data);
  };

  render() {
    return (
      <RegisterFormView
        registerData={this.props.registerData}
        runtime={this.props.runtime}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapState = state => ({
  registerData: state.registerData,
  runtime: state.runtime,
});

const mapDispatch = dispatch => {
  return {
    getRegisterData: () => dispatch(getRegisterData()),
    registerUser: data => dispatch(registerUser(data)),
  };
};

RegisterForm.propTypes = {
  getRegisterData: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  registerData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  runtime: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default connect(mapState, mapDispatch)(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/RegisterForm/RegisterForm.js